
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mailroom",
      function () {
        return require("private-next-pages/mailroom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mailroom"])
      });
    }
  